<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div
      slot="header"
      class="flex flex-wrap-reverse items-center flex-grow justify-between"
    >
      <div class="flex flex-wrap-reverse items-center">
        <vs-button
          type="filled"
          icon-pack="feather"
          icon="icon-plus"
          @click="
            $router.push(`/marcas/nova-marca`).catch((err) => {})
          "
          class="
            p-3
            mb-4
            mr-4
            rounded-lg
            cursor-pointer
            flex
            items-center
            justify-between
            bg-success
          "
          >Nova Marca</vs-button
        >
      </div>
    </div>
    <vue-good-table
      ref="my-table"
      selectionInfoClass="mytable"
      style="width: 100%"
      styleClass="vgt-table condensed"
      :search-options="{
        enabled: true,
        trigger: '',
        placeholder: 'Procurar',
        skipDiacritics: true,
      }"
      :pagination-options="paginationOptions"
      :columns="columns"
      :rows="trademark"
      @on-row-click="onRowClick"
    >
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>
      <template slot="table-row" slot-scope="trademark">
        <span
          class="font-medium"
          @click.stop="open(trademark.row.idTrademark)"
          v-if="trademark.column.field == 'idTrademark'"
        >
          <vs-chip color="#1E90FF">{{
            trademark.row.idTrademark
          }}</vs-chip>
        </span>
        <span
          @click.stop="open(trademark.row.idTrademark)"
          class="font-medium"
          v-if="trademark.column.field == 'name'"
        >
          {{ trademark.row.name }}
        </span>
        <span
          class="font-medium"
          @click.stop="open(trademark.row.idTrademark)"
          v-if="trademark.column.field == 'userName'"
        >
          {{ trademark.row.userName }}
        </span>
      </template>
    </vue-good-table>
    <vs-popup class="Confirmar" title="Remover" :active.sync="popupActive">
      <p>Tem certeza que deseja remover esse item para lixeira?</p>
      <div class="vx-row">
        <div class="vx-col w-full mt-5">
          <vs-button
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-trash-2"
            @click="deleteData()"
            class="float-right"
            >Remover</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

 
<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { VueGoodTable },
  data() {
    return {
      trademark: [],
      itemsPerPage: 100,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      columns: [],
      popupActive: false,
      idDelete: null,
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
    };
  },
  computed: {},
  methods: {
    async showPoupUp(idTrademark) {
      this.popupActive = true;
      this.idDelete = idTrademark;
    },
    async deleteData() {
      this.$vs.loading();
      let idTrademark = this.idDelete;
      try {
        const response = await axios.post(`${baseApiUrl}/trademark/delete`, {
          idTrademark,
        });
        this.popupActive = false;
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        await this.getAllPartsRequest();
        this.$vs.loading.close();
        this.popupActive = false;
      }
    },
    open(idTrademark) {
      this.$router
        .push(`/marcas/editar/${idTrademark}`)
        .catch((err) => {});
    },
    async getAllTrademark() {
      this.$vs.loading();
      try {
        const response = await axios.get(
          `${baseApiUrl}/trademark/getAllTrademark`
        );
        this.trademark = response.data;
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    onRowClick(params) {
      // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idTrademark",
          tdClass: "align-middle",
        },
        {
          label: "Nome da Marca",
          field: "name",
          tdClass: "align-middle",
        },
        {
          label: "Criada/Modificada por",
          field: "userName",
          tdClass: "align-middle",
        },
      ];
    },
  },
  async created() {
    await this.getAllTrademark();
    this.mountTable();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>